import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { Dialog } from "primereact/dialog";
import { selectPositiveItemDeleteDialog, selectPositiveItemsToDelete } from "../../store/selectors/positiveItemSelectors";
import { Button } from "primereact/button";
import { useState } from "react";
import { deletePositiveItem } from "../../services/positiveItemService";
import { deleteItem, setShowDeleteSelected } from "../../store/slices/positiveItemSlice";

export const PositiveItemDeleteDialog = () => {
    const dispatch = useAppDispatch();

    const toDelete = useAppSelector(selectPositiveItemsToDelete);
    const showDialog = useAppSelector(selectPositiveItemDeleteDialog);

    const [loading, setLoading] = useState(false);

    if (!toDelete) {
        return null;
    }

    const onHide = () => {
        dispatch(setShowDeleteSelected(false));
    };

    const onDelete = async () => {
        if (toDelete.length) {
            setLoading(true);

            const response = await deletePositiveItem(toDelete);
    
            if (response) {
                dispatch(deleteItem(toDelete));
                onHide();
            }
    
            setLoading(false);
        }
    };

    const message = "Are you sure you wish to delete the selected positive item(s)?";

    const footerContent = () => (
        <div className="flex justify-content-end">
            <Button label="Cancel" onClick={onHide} data-cy="cancel-button"/>
            <Button severity="danger" label={loading ? undefined : "Delete"} icon={loading ? "pi pi-spin pi-spinner" : undefined} onClick={onDelete} disabled={loading} data-cy="delete-button"/>
        </div>
    );

    return (
        <Dialog header="Delete Selected?" visible={showDialog} className="small-dialog" draggable={false} onHide={onHide} footer={footerContent} data-cy="delete-selected">
            <p>{message}</p>
        </Dialog>
    )
}